import { useState } from 'react';

import { Button, Col, Grid, Input, Row } from 'antd';

import markerSvg from 'assets/images/marker.svg';
import newLogoBlinket from 'assets/images/new-blinket-logo.svg';
import logoBlinketNoLetters from 'assets/images/new-logo-no-letters.svg';

import Banner from './Banner';
import styles from './styles.module.css';

const { Search } = Input;

type HeaderProps = {
  selectedLocale: string;
  setOpenLocaleModal: (open: boolean) => void;
  handleSearch: (value: string) => void;
};

const Header = ({ selectedLocale, handleSearch, setOpenLocaleModal }: HeaderProps) => {
  const [showBanner, setShowBanner] = useState(true);
  const screen = Grid.useBreakpoint();

  return (
    <>
      {showBanner && <Banner setShowBanner={setShowBanner} />}
      <div className={styles.container}>
        <Row gutter={[10, 10]} align={'middle'} justify={'center'} className={styles.row}>
          <Col xs={0} sm={0} md={0} lg={4}>
            <img src={newLogoBlinket} />
          </Col>
          <Col xs={6} sm={6} md={2} lg={0}>
            <img src={logoBlinketNoLetters} />
          </Col>
          <Col xs={18} md={10}>
            <Search
              id='search-input'
              placeholder='Pesquisar por evento'
              className={styles.fullWidth}
              onSearch={handleSearch}
            />
          </Col>
          <Col xs={0} md={5}>
            <Button
              id='locale-modal-button'
              icon={<img src={markerSvg} alt='marker icon' />}
              onClick={() => setOpenLocaleModal(true)}
              className={styles.primaryText}
            >
              {selectedLocale}
            </Button>
          </Col>
          <Col xs={0} md={5} className={screen.lg ? styles.blinketButtonContainer : ''}>
            <a href={'https://www.eduzz.com/produtos/blinket'} target='_blank' rel='noreferrer'>
              <Button id='header-meet-blinket' className={styles.primaryText}>
                Conheça a Blinket
              </Button>
            </a>
          </Col>
        </Row>
        <Row className={styles.borderBottom}>
          <Col xs={24} md={0} className={styles.mobileLocale}>
            <Button
              id='locale-modal-button-mobile'
              icon={<img src={markerSvg} alt='marker icon' />}
              onClick={() => setOpenLocaleModal(true)}
              className={styles.primaryText}
            >
              {selectedLocale}
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Header;
